import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import AnalyticsService from '../../../../services/AnalyticsService';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutShippingMethod from '../CheckoutShippingMethod';
import CheckoutNoShippingAvailable from "../CheckoutNoShippingAvailable";

const CheckoutShippingMethodModule = ({ analyticsService, checkoutStore, onOrderUpdate, orderNumber }) => {
  const { order } = checkoutStore;
  const { shippingMethodAlerts, hasShippingOptions } = order;

  const handleUpdate = (args) => {
    onOrderUpdate({
      module: CheckoutPageModule.SHIPPING_METHOD_MODULE,
      ...args,
    });
    // Only send analytics event if not explicitly skipped (e.g., for pickup point updates)
    if (!args.skipAnalytics) {
      analyticsService.addShippingInfo({ products: order.productList, productsTotal: order.analytics.value });
    }
  };

  return (
    <CheckoutModule
      className="CheckoutShippingMethodModule"
      generalAlerts={shippingMethodAlerts.general}
      errorAlerts={shippingMethodAlerts.errors}
      title={
        <FormattedMessage
          id="checkout.shippingModule.title"
          defaultMessage="Select shipping method"
        />
      }
      orderNumber={orderNumber}
      module={CheckoutPageModule.SHIPPING_METHOD_MODULE}
    >
      {hasShippingOptions ? (
        <CheckoutShippingMethod
          onOrderUpdate={handleUpdate}
          orderNumber={orderNumber}
        />
        ) :
        <CheckoutNoShippingAvailable />
      }
    </CheckoutModule>
  );
};

CheckoutShippingMethodModule.propTypes = {
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject('analyticsService', 'checkoutStore')(observer(CheckoutShippingMethodModule));
